import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminGloryValuePage() { return <ModuleAdminPage title="聚耀值" code="glory-value" text="管理聚耀值來源與會員身份輔助設定，聚耀值不可扣除。" />; }
